export default __webpack_public_path__ + "static/media/move_lab_logo_white.d2d1409e.png";